export default "__VITE_ASSET__B9kiMUUV__"